export const DATE_FORMAT = 'DD/MM/YYYY';
export const PROSPECT_DATE_FORMAT = 'YYYY-MM-DD'
export const EIRCODE_FINDER_URL = 'https://finder.eircode.ie/#/';
export const MARKETING_PREFERENCES_NOTE = 'From time to time we may wish to let you know about other eir products, services, sponsorship and promotional activities. What’s the best way to contact you?';
export const EIRCODE_LOGO_IMAGE_PATH = '/.galleries/eir/checkout/eircode-logo-small.png';
export const TERMS_AND_CONDITIONS_LINK = 'https://www.eir.ie/opencms/export/sites/default/.content/pdf/terms/Terms_and_Conditions_of_the_eir_Mobile_Service.pdf';
export const DIRECT_DEBIT_INFORMATION = 'All bill pay customers are required to set up direct debit. In order to proceed please agree to the direct debit terms and conditions. If you are already set up on direct debit with eir we ask that you re-enter your details for security reasons. If you are not the sole signatory, you will need to fill out a direct debit mandate.'
export const DEBIT_TERMS_AND_CONDITIONS = 'I acknowledge and agree that this acceptance constitutes an instruction to my bank to pay direct debits of a variable amount from my bank account identified below at the request of eir. I will inform the bank in writing if I wish to cancel this direct debit. I accept that direct debit details are required to avail of this product and my offer/account will be cancelled if these details are inaccurate or not accepted by the bank. Direct debit deductions will be taken from my account on or after the 14th day after the bill issue date. '

const REVIEW_ORDER_URL = '/review';
const CUSTOMER_DETAILS_URL = '/customerdetails';
const PAYMENT_URL = '/payment';
const CONFIRMATION_URL = '/confirmation';

const CONTACT_MOBILE_NUMBER = 'This mobile number will be used in case we need to contact you regarding your delivery.';
const DATE_OF_BIRTH_TOOLTIP = 'You need to be over 18 years old to buy prepay.';

const EXDIRECTORY = 'Ex-Directory - Not available for Directory Enquiries and not in the Phonebook';
const LISTED = 'Listed - Available for Directory Enquiries and in the Phonebook';
const UNLISTED = 'Unlisted - Available for Directory Enquiries but not in the Phonebook';

export const CHECKOUT_URLS = {
    REVIEW_ORDER_URL,
    CUSTOMER_DETAILS_URL,
    PAYMENT_URL,
    CONFIRMATION_URL,
};

export const TOOLTIP_TEXT = {
    CONTACT_MOBILE_NUMBER,
    DATE_OF_BIRTH_TOOLTIP
};

export const DIRECTORY_PREFERENCES = {
    EXDIRECTORY,
    LISTED,
    UNLISTED,
};

export const MARKETING_PREFERENCES = [
    {
        'name': 'As an existing eir customer',
        'permission': 'active',
        'enabled': false,
        'preferenceList': [
            {
                'enabled': false,
                'name': 'Email',
                'permission': 'EMAIL'
            },
            {
                'enabled': false,
                'name': 'SMS',
                'permission': 'SMS'
            },
            {
                'enabled': false,
                'name': 'Phone',
                'permission': 'Phone'
            },
            {
                'enabled': false,
                'name': 'Door to door',
                'permission': 'D2D'
            },
            {
                'enabled': false,
                'name': 'Direct mail',
                'permission': 'DirectMail'
            }
        ]
    }
];

export const SECURITY_QUESTIONS =
{
    'securityQuestions': [
        {
            'code': 'MEMORABLE_DATE',
            'question': ' Memorable Date'
        },
        {
            'code': 'MEMORABLE_WORD',
            'question': ' Memorable word'
        }
    ]
}
